export default "__VITE_ASSET__5b19c753__"